import ErrorBoundary from "components/Error/errorBoundary";
import React, {useEffect, useState} from 'react';
import {useSearchContext} from "v4/contexts/SearchContext/SearchContext";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import ListingEntityLayout from "v4/layouts/ListingEntityLayout/ListingEntityLayout";
import ListingHeaderEntityLayout from "v4/layouts/ListingHeaderEntityLayout/ListingHeaderEntityLayout";

export default function SearchSectionContent({entity, title, resultsText, searchText, rowActions, tableClassName}) {
    const {t} = usePolTranslation();
    const [totalItems, setTotalItems] = useState(null);
    const {setSearchbar, searchbar} = useSearchContext();

    useEffect(() => {
        if (!searchText || searchbar === searchText) return;

        setSearchbar(searchText);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchText]);

    return (
        <div className="search-section">
            <ErrorBoundary>
                <ListingHeaderEntityLayout totalItems={totalItems}
                                           title={title}
                                           pageType={tableClassName}
                                           resultsText={
                                               t(`${resultsText}${(totalItems > 1) ? 's' : ''}`.replace(/ss$/, 's'), {count: totalItems})
                                           }/>
                <ListingEntityLayout
                    entity={entity}
                    tableClassName={tableClassName}
                    rowActions={rowActions}
                    toolsRender={() => null}
                    setTotalItems={setTotalItems}
                />
            </ErrorBoundary>
        </div>
    );
}
